import React from 'react'
import PropTypes from 'prop-types'
import ListerPage from '../containers/ListerPage/ListerPage'
import executeBrowse from '../actions/executeBrowse'
import formatActionPayload from '../helpers/RoutingHelper'

class Browse extends React.Component {
  static fetchData(routeMatch, url, store, fetchr) {
    const context = {
      reduxStore: store,
      service: fetchr
    }

    const payload = formatActionPayload(routeMatch, url)

    return new Promise((resolve, reject) => {
      executeBrowse(context, payload, resolve)
    })
  }

  render() {
    return <ListerPage />
  }
}

Browse.contextTypes = {
  fetchr: PropTypes.object
}

export default Browse
